// @flow

// Helper function for matching against an ADT.
// match :: Matcher => Function -> Entity => Any
export function match<A, B>(matcher: A): (match: (matcher: A) => B) => B {
  return match => match(matcher);
}



// WEBPACK FOOTER //
// ./src/helpers/adt.js